import React, { useState } from "react";
import Navbar from "../NavBar";
import { Layout, Typography, Row, Col } from "antd";
import Footer from "../Footer";
import { CheckCircleOutlined } from '@ant-design/icons';
import Features from "../Features";
import TextGifSection from "../TextGifSection";
import Popup from "../popup";

const { Content } = Layout;
const { Title, Text } = Typography;

const ForRecruiters = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const showModal = () => {
    setModalVisible(true);
  };

  const handleClose = () => {
    setModalVisible(false);
  };

  const signInUser = (pathName) => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const isLocalhost = baseUrl.includes('localhost') || baseUrl.includes('127.0.0.1');
    const protocol = isLocalhost ? 'http://' : 'https://';
    const cleanBaseUrl = baseUrl.replace(/^https?:\/\//, '');
    const redirectTo = `${protocol}${cleanBaseUrl}/${pathName}?path=finishSignup`;
    window.location.href = redirectTo;
  };

  const handleStartTrial = () => {
    const path = process.env.REACT_APP_OFFICE_AUTH_ENDPOINT;
    setLoading(true);
    if (path) signInUser(path);
  };

  return (
    <div>
      {/* Header */}
      <div className="landing-page-content">
        <Layout className="layout">
          <Navbar />
          <Content style={{ padding: "0 50px" }}>
            {/* Hero Section - Recruiter Focused */}
            <div className="hero-section">
              <div className="hero-container">
                <div className="hero-background-shapes">
                  <div className="diamond-right"></div>
                  <div className="circle-left"></div>
                  <div className="diamond-left"></div>
                </div>
                <h1 className="hero-title">
                  <span className="gradient-word">AI Does the Heavy Lifting</span>, You Make the <span className="gradient-word">Perfect Matches</span>
                </h1>
                
                <div className="hero-description" style={{ fontSize: '20px', lineHeight: '1.6', maxWidth: '750px' }}>
                  <p style={{ marginBottom: '30px', fontWeight: '500', color: '#333', fontSize: '22px', marginTop: '0px' }}>
                    Complete recruiting platform: job board, sourcing, tracking and auto-updating talent pools. Deliver extraordinary experiences that drive client and candidate retention.
                  </p>
                </div>

                {/* Key Benefits for Recruiters */}
                <Row gutter={[48, 16]} style={{ marginTop: 0, textAlign: 'center', marginBottom: 40 }} justify="space-around">
                  <Col xs={24} sm={12}>
                    <div className="trial-content">
                      <CheckCircleOutlined style={{ color: 'green', marginRight: 8, fontSize: '20px' }} />
                      <Text style={{ fontSize: '16px', fontWeight: '600' }}>7-Day Free Trial</Text>
                    </div>
                  </Col>
                  <Col xs={24} sm={12}>
                    <div className="trial-content">
                      <CheckCircleOutlined style={{ color: 'green', marginRight: 8, fontSize: '20px' }} />
                      <Text style={{ fontSize: '16px', fontWeight: '600' }}>No Credit Card Required</Text>
                    </div>
                  </Col>
                </Row>

                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                  <button 
                    style={{
                      background: '#d1bd21',
                      color: 'black',
                      border: 'none',
                      padding: '16px 32px',
                      borderRadius: '8px',
                      fontSize: '18px',
                      fontWeight: '600',
                      cursor: 'pointer'
                    }}
                    onClick={handleStartTrial}
                    disabled={loading}
                  >
                    Start Free Trial
                    {loading && <span style={{ marginLeft: '8px' }}>...</span>}
                  </button>
                </div>
              </div>
            </div>
          </Content>
        </Layout>
      </div>

      {/* Retain Top Talent Section */}
      <TextGifSection />
    
      {/* Key Features for Recruiters */}
      <Features />

      {/* Closing CTA Section - Full Width */}
      <div style={{ 
        background: "linear-gradient(135deg, #6841eb 0%, #764ba2 100%)", 
        padding: "clamp(40px, 8vw, 80px) 15px", 
        textAlign: "center",
        width: "100vw",
        margin: 0,
        marginLeft: "calc(-50vw + 50%)",
        boxSizing: "border-box",
        position: "relative"
      }}>
        <div style={{ maxWidth: "800px", margin: "0 auto", padding: "0 20px" }}>
          <Title level={2} style={{ 
            color: "white", 
            marginBottom: "24px", 
            fontSize: "clamp(1.8rem, 4vw, 2.5rem)", 
            fontWeight: "800",
            lineHeight: "1.2"
          }}>
            Ready to 4x Your Recruiting Productivity?
          </Title>
          <Text style={{ 
            color: "rgba(255,255,255,0.9)", 
            fontSize: "clamp(16px, 3vw, 20px)", 
            display: "block", 
            marginBottom: "40px", 
            lineHeight: "1.6" 
          }}>
            Join hundreds of recruitment teams using ChronoFlow to fill positions faster, reduce manual work, and deliver exceptional candidate experiences.
          </Text>
          
          {/* Benefits */}
          <Row gutter={[32, 16]} style={{ marginBottom: "48px", justifyContent: "center" }}>
            <Col xs={24} sm={8}>
              <div style={{ textAlign: "center" }}>
                <CheckCircleOutlined style={{ color: "#d1bd21", fontSize: "24px", marginBottom: "8px" }} />
                <Text style={{ color: "white", fontSize: "16px", fontWeight: "600", display: "block" }}>
                  7-Day Free Trial
                </Text>
              </div>
            </Col>
            <Col xs={24} sm={8}>
              <div style={{ textAlign: "center" }}>
                <CheckCircleOutlined style={{ color: "#d1bd21", fontSize: "24px", marginBottom: "8px" }} />
                <Text style={{ color: "white", fontSize: "16px", fontWeight: "600", display: "block" }}>
                  Setup in 5 Minutes
                </Text>
              </div>
            </Col>
            <Col xs={24} sm={8}>
              <div style={{ textAlign: "center" }}>
                <CheckCircleOutlined style={{ color: "#d1bd21", fontSize: "24px", marginBottom: "8px" }} />
                <Text style={{ color: "white", fontSize: "16px", fontWeight: "600", display: "block" }}>
                  No Credit Card Required
                </Text>
              </div>
            </Col>
          </Row>

          {/* CTA Button */}
          <div style={{ textAlign: "center" }}>
            <button 
              style={{
                background: "#d1bd21",
                color: "black",
                border: "none",
                padding: "18px 36px",
                borderRadius: "8px",
                fontSize: "18px",
                fontWeight: "700",
                cursor: "pointer",
                transition: "all 0.3s ease",
                minWidth: "180px"
              }}
              onMouseOver={(e) => e.target.style.background = "#b8a01d"}
              onMouseOut={(e) => e.target.style.background = "#d1bd21"}
              onClick={handleStartTrial}
              disabled={loading}
            >
              Start Free Trial
              {loading && <span style={{ marginLeft: '8px' }}>...</span>}
            </button>

          </div>

          <Text style={{ color: "rgba(255,255,255,0.8)", fontSize: "14px", marginTop: "24px", display: "block" }}>
            Questions? 
            <span 
              onClick={showModal}
              style={{ 
                color: "#d1bd21", 
                cursor: "pointer", 
                textDecoration: "underline",
                marginLeft: "4px"
              }}
            >
              Contact Us
            </span>
          </Text>
        </div>
      </div>

      <Footer />
      
      {/* Contact Modal */}
      <Popup visible={modalVisible} onClose={handleClose} />
    </div>
  );
};

export default ForRecruiters;